/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createNumber } from '../../factoriesAny.js';
export var numberDependencies = {
  typedDependencies: typedDependencies,
  createNumber: createNumber
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesNumber.generated.js
// module id = 233
// module chunks = 0